<template>
	<div class="hide-outline">
		<TopPanel
			:units="[$t('file_view.singular'), $t('file_view.plural'), $t('file_view.new')]"
			:pagination="pagination"
			:showCustomer="true"
			:orderBys="orderBys"
			:orderBy="searchParams.orderBy"
			hideAdd
			@search="search"
			@orderBy="orderBy"
		/>
		<div class="main-view columns">
			<FileList
				:files="files"
				@delete="askToDeleteFile"
				@search="getFiles(1)"
				@save="save"
				@download="download"
			/>
		</div>
		<DeleteModal
			v-if="showDelete"
			@confirm="deleteSelected"
			@cancel="cancelDelete"
			:message="deleteMessage"
		/>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import TopPanel from '@/components/TopPanel';
import FileList from './components/FileList';
import DeleteModal from '@/components/DeleteModal';

export default {
	components: {
		TopPanel,
		FileList,
		DeleteModal
	},
	data: () => ({
		showDelete: false,
		selectedFile: {},
	}),

	computed: {
		...mapGetters('user', ['getActiveCustomer']),
		...mapGetters('fileStore', ['files', 'pagination']),
		...mapState('fileStore', ['searchParams']),

		deleteMessage() {
			return this.$t('file_view.confirm_delete', { name: this.selectedFile.name });
		},

		orderBys() {
			return [
				{ name: this.$t('common.order_name'), value: 'Name' },
				{ name: this.$t('common.order_created'), value: 'Created' }
			];
		},
	},

	watch: {
		'getActiveCustomer.id'() {
			this.getFiles(1);
		}
	},

	created() {
		this.getFiles(1);
	},

	methods: {
		...mapActions('user', ['setActiveCustomer']),
		...mapActions('fileStore', [
			'getFiles',
			'saveFile',
			'deleteFile',
			'downloadFile'
		]),


		search(searchValue) {
			this.searchParams.name = searchValue;
			this.getFiles(1);
		},

		orderBy(orderBy) {
			this.searchParams.orderBy = orderBy;
			this.getFiles(1);
		},

		askToDeleteFile(file) {
			this.selectedFile = file;
			this.showDelete = true;
		},

		cancelDelete() {
			this.showDelete = false;
			this.selectedFile = {};
		},

		deleteSelected() {
			this.deleteFile(this.selectedFile).then(() => {
				this.cancelDelete();
			});
		},

		save(file) {
			const params = {
				customerId: this.getActiveCustomer?.id,
				file,
				documentType: 1
			};

			this.saveFile(params).then(() => {
				this.getFiles(1);
			});
		},

		download(file) {
			this.downloadFile(file.id).then(data => {
				const url = window.URL.createObjectURL(new Blob([data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', file.name);
				document.body.appendChild(link);
				link.click();
				this.$nextTick(() => {
					document.body.removeChild(link);
				});
			});
		}
	}
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";
@import "@/assets/colors.scss";

.panel.info-panel {
  position: absolute;
  pointer-events: none;
  margin-left: -8px;
  top: $navbar-height + 0.75rem;
  background-color: transparent;
  width: calc(100% - 300px);
  color: $white;
  border-radius: 0;
  z-index: 1;
  &.mobile {
    z-index: 4;
    position: fixed;
  }
}
</style>
